 import { Component } from '@angular/core';


@Component({
  selector: 'shipping-services',
  template: require('./news.component.html'),
})

export class NewsComponent {
  public isMenu = 0;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/news/news.component.ts